module.exports = __webpack_public_path__ + "static/media/18ECA35.54f44c37.jpg";